import React from 'react';
import { Users, MapPin } from 'lucide-react';

const WomensWingCoordinators = () => {
  const coordinators = [
    { name: "Mrs. Vasuki", qualification: "M.A.", district: "Central Chennai" },
    { name: "Mrs. Selvasundari", qualification: "B.Sc., B.Ed.", district: "South Chennai" },
    { name: "Mrs. Selva kumari", qualification: "M.A.", district: "North Chennai" },
    { name: "Mrs. Arul selvi", qualification: "M.Sc., M.Phil., B.Ed., M.Sc. (Psy)", district: "Thiruvallur" },
    { name: "Dr. Renuka Devi", qualification: "M.D., D.M.", district: "Cuddalore" },
    { name: "Dr. Uma Maheswari", qualification: "B.E., M.B.A., M.Phil., Ph.D.", district: "Pondicherry UT" },
    { name: "Mrs. Nandhini devi", qualification: "B.A., D.T.Ed.", district: "Ariyalur District" },
    { name: "Mrs. Pandi selvi", qualification: "M.Com.", district: "Pudukkottai District" },
    { name: "Mrs. Maithri Yazhini", qualification: "M.Sc., HDCM., DASc.", district: "Dindigul District" },
    { name: "Dr. Guna Gomathi", qualification: "M.B.B.S., DGO RTD JD, DMRHS & FW", district: "Perambalur District" },
    { name: "Mrs. Sarojini Priya", qualification: "B.Pharm.", district: "Kallakurichi District" },
    { name: "Mrs. Radha Jayalakshmi", qualification: "M.Com., M.B.A.", district: "Vellore and Salem District" },
    { name: "Dr. Manimozhi", qualification: "M.B.B.S., DLO", district: "Sivagangai District" },
    { name: "Mrs. Sindhuja", qualification: "B.A., BLIS, MLIS, MPhil", district: "Chengalpet District" }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-pink-50 via-purple-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-pink-100 rounded-full mb-4">
            <Users className="w-5 h-5 text-pink-600" />
            <span className="text-sm font-semibold text-pink-700">Women's Leadership</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            MMT Women's Wing
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-2">
            Empowering women through Buddhist values and social transformation
          </p>
        </div>

        {/* President Spotlight */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-pink-50 to-purple-100 rounded-2xl p-8 md:p-10 shadow-xl border-t-4 border-pink-600">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <img 
                src="https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/gnwt3jfj_Sasipriya.jpeg" 
                alt="Dr. P. Sasipriya - President, MMT Women's Wing" 
                className="w-48 h-48 rounded-full object-cover border-8 border-white shadow-2xl"
              />
              <div className="flex-1 text-center md:text-left">
                <div className="inline-block bg-pink-600 text-white px-6 py-2 rounded-full font-bold text-sm mb-3">
                  PRESIDENT
                </div>
                <h3 className="text-4xl font-bold text-pink-900 mb-2">Dr. P. Sasipriya</h3>
                <p className="text-xl text-pink-700 font-semibold mb-4">M.B.B.S., M.D.R.T.</p>
                <p className="text-gray-700 leading-relaxed">
                  Leading the MMT Women's Wing in empowering women across Tamil Nadu through Buddhist teachings, social equality initiatives, and community development programs.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* District Coordinators Section Header */}
        <div className="text-center mb-8">
          <h3 className="text-3xl font-bold text-gray-900 mb-2">
            District Coordinators
          </h3>
          <p className="text-lg text-gray-600">
            Across Tamil Nadu and Pondicherry
          </p>
        </div>

        {/* Coordinators Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {coordinators.map((coordinator, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-pink-500"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Users className="w-5 h-5 text-pink-600" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900 mb-1">
                    {coordinator.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-2">
                    {coordinator.qualification}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 mt-3 pt-3 border-t border-gray-100">
                <MapPin className="w-4 h-4 text-pink-500 flex-shrink-0" />
                <p className="text-sm font-semibold text-pink-700">
                  {coordinator.district}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer Note */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 italic">
            Leading the Buddhist revival movement and women's empowerment across 14 districts
          </p>
        </div>
      </div>
    </section>
  );
};

export default WomensWingCoordinators;
